import { render, staticRenderFns } from "./ed-list-homework-history.component.vue?vue&type=template&id=17441864&scoped=true&"
import script from "./ed-list-homework-history.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-homework-history.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-homework-history.component.scss?vue&type=style&index=0&id=17441864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17441864",
  null
  
)

export default component.exports